import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhotovoltaik = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Ebene_1",
	xmlns: "http://www.w3.org/2000/svg",
	width: 95.466,
	height: 89,
	viewBox: "0 0 200 200",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#00488E",
			className: "cls-1",
			d: "M105,165h65.53l-.55-5.5c-.21-2.06-5.09-50.59-10.12-70.72l-.95-3.79h-26.81c1.17-3.62,1.79-7.54,1.79-11.66,0-19.63-13.71-33.34-33.34-33.34s-33.34,13.71-33.34,33.34c0,4.12,.62,8.04,1.79,11.66h-27.61l-1.14,3.42c-5.12,15.37-10.03,68.86-10.24,71.13l-.5,5.45H95v15H60v10h80v-10h-35v-15Zm-31.77-50h21.77v15h-22.84l1.07-15Zm-11.1,15h-18.89c.6-4.98,1.27-10.11,1.97-15h18l-1.07,15Zm12.53-35h20.34v10h-21.06l.71-10Zm50.69,0l.71,10h-21.06v-10h20.34Zm2.5,35h-22.84v-15h21.77l1.07,15Zm8.95-15h17.67c.73,4.96,1.42,10.07,2.05,15h-18.64l-1.07-15Zm-41.8,25v15h-24.63l1.07-15h23.56Zm10,0h23.56l1.07,15h-24.63v-15Zm34.66,15l-1.07-15h19.16c.72,6.03,1.3,11.31,1.7,15h-19.79Zm13.24-50h-16.81l-.71-10h15.65c.63,2.96,1.26,6.36,1.88,10Zm-75.69-31.66c0-14.18,9.16-23.34,23.34-23.34s23.34,9.16,23.34,23.34c0,4.32-.87,8.29-2.52,11.66h-41.63c-1.66-3.37-2.52-7.34-2.52-11.66Zm-12.58,21.66l-.71,10h-17.15c.66-3.83,1.33-7.26,2.01-10h15.85Zm-22.55,45h19.34l-1.07,15h-19.84c.36-3.69,.91-8.99,1.57-15Z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 95,
			y: 8.33,
			width: 10,
			height: 21.67
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 127.47,
			y: 28.91,
			width: 21.67,
			height: 10,
			transform: "translate(16.53 107.73) rotate(-45)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 143.33,
			y: 65,
			width: 21.67,
			height: 10
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 35,
			y: 65,
			width: 21.67,
			height: 10
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 56.7,
			y: 23.07,
			width: 10,
			height: 21.67,
			transform: "translate(-5.9 53.56) rotate(-45)"
		})
	]
});
export default SvgPhotovoltaik;
